import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

document.querySelectorAll('.c-shortcode-swiper').forEach((wrapper) => {
  const innerEl = wrapper.querySelector('.c-shortcode-swiper__inner');
  const paginationEl = wrapper.querySelector('.swiper-pagination');
  const prevEl = wrapper.querySelector('.c-shortcode-swiper__btn--prev');
  const nextEl = wrapper.querySelector('.c-shortcode-swiper__btn--next');
  const captionEl = wrapper.querySelector('.c-shortcode-swiper__caption-display');

  if (!innerEl || !paginationEl) return;

  const captions = wrapper.dataset.captions ? wrapper.dataset.captions.split(',').map((c) => c.trim()) : [];

  const updateCaption = (sw) => {
    if (captionEl) captionEl.textContent = captions[sw.realIndex] || '';
  };

  const swiper = new Swiper(innerEl, {
    loop: true,
    speed: 500,
    pagination: {
      el: paginationEl,
      type: 'fraction',
    },
    navigation: {
      prevEl,
      nextEl,
      disabledClass: 'is-disabled',
    },
    on: {
      init(sw) {
        updateCaption(sw);
      },
      slideChange(sw) {
        updateCaption(sw);
      },
    },
  });

  swiper.init();
});
